module.exports = __webpack_public_path__ + "media/fonts/material-design-icons/materialdesignicons-webfont-d45a533225a265d8bcf0242602394b46.svg";